import {
    checkIfSidebarTrafficStarsNeedsToBeShown,
    generateInformationText,
} from "@modules/saved-searches/saved-items/generation.ts"
import { getNoSearchedTemplate } from "@modules/saved-searches/saved-items/user-search-templates.ts"

const deleteSearchConfirmButton = document.getElementById("user-search-delete-button")
const clearAllSearchConfirmButton = document.getElementById("user-search-empty-button")
const clearAllButtonWithSideBar = document.getElementById("remove-all-button")
const singleDeleteButtons = document.getElementsByClassName("remove-single")
const confirmDeleteTitleCard = document.getElementById("user-search-name")

export function registerRemoveButtons() {
    let userSearchId: number | undefined = -1
    let userSearchName: string | undefined = undefined

    for (const button of singleDeleteButtons) {
        button.addEventListener("click", (event) => {
            let htmlElement = event.currentTarget as HTMLElement

            if (!(htmlElement instanceof HTMLAnchorElement)) {
                htmlElement = htmlElement.closest("a") as HTMLAnchorElement
            }

            userSearchId = Number(htmlElement.dataset["id"])
            userSearchName = htmlElement.dataset["name"]

            if (confirmDeleteTitleCard) {
                confirmDeleteTitleCard.textContent = userSearchName || "LOADING ERROR"
            }
        })
    }

    clearAllSearchConfirmButton?.addEventListener("click", async () => {
        await clearAllSavedSearches()

        hideClearAllButton()
        updateStatusBarAfterDelete()

        const content = document.getElementById("deine-suchen")
        if (!content) return
        content.innerHTML = getNoSearchedTemplate()
    })

    deleteSearchConfirmButton?.addEventListener("click", async () => {
        if (!userSearchId || userSearchId === -1) return

        await deleteSelectedCard(userSearchId)

        const statusBar = document.getElementById("information-count-searches")
        const currentCount = Number(statusBar?.getAttribute("data-count"))
        checkIfSidebarTrafficStarsNeedsToBeShown(currentCount - 1)

        updateStatusBarAfterDelete()
    })
}

function hideClearAllButton() {
    if (!clearAllButtonWithSideBar) return

    clearAllButtonWithSideBar.classList.add("hidden")
}

function getUserId() {
    return userData.userId
}

function updateStatusBarAfterDelete(clearedAll = false) {
    const statusBar = document.getElementById("information-count-searches")

    if (!statusBar) return

    if (clearedAll) {
        statusBar.setAttribute("data-count", "0")
        statusBar.innerHTML = generateInformationText(0)

        return
    }

    const currentCount = Number(statusBar.getAttribute("data-count"))
    const newCount = currentCount - 1
    statusBar.setAttribute("data-count", newCount.toString())
    statusBar.innerHTML = generateInformationText(newCount)
}
async function deleteSelectedCard(savedSearchId: number) {
    try {
        await fetch(`/api/user-search/${getUserId()}/delete`, {
            method: "POST",
            body: JSON.stringify({
                id: savedSearchId,
                confirm: true,
            }),
        })

        const itemsToBeDeleted = document.querySelectorAll(
            `#saved-searches-gallery .item[data-id="${savedSearchId}"], #deine-suchen-dropdown .dropdown-list-item[data-id="${savedSearchId}"]`,
        )
        for (const card of itemsToBeDeleted) {
            card.remove()
        }

        const currentCount = Number(document.getElementById("information-count-searches")?.getAttribute("data-count"))
        if (currentCount <= 1) {
            document.querySelector("#deine-suchen-dropdown .dropdown-text")?.classList.remove("hidden")
            document.querySelector("#deine-suchen-dropdown .dropdown-list")?.classList.add("hidden")
            document.querySelector("#deine-suchen-dropdown .dropdown-footer")?.classList.add("hidden")
        }
    } catch (e) {
        console.error("Error deleting saved search:", e)
        return
    }
}

async function clearAllSavedSearches() {
    try {
        await fetch(`/api/user-search/${getUserId()}/clear-all`, {
            method: "POST",
            body: JSON.stringify({
                confirm: true,
            }),
        })

        const allItems = document.querySelectorAll(
            "#saved-searches-gallery .item, #deine-suchen-dropdown .dropdown-list-item",
        )

        if (!allItems) return

        for (const card of allItems) {
            card.remove()
        }

        document.querySelector("#deine-suchen-dropdown .dropdown-text")?.classList.remove("hidden")
        document.querySelector("#deine-suchen-dropdown .dropdown-list")?.classList.add("hidden")
        document.querySelector("#deine-suchen-dropdown .dropdown-footer")?.classList.add("hidden")
    } catch (e) {
        console.error("Error deleting saved search:", e)
        return
    }
}
